import { createAction } from '@reduxjs/toolkit';

export const STOP_ALL_ENGINE_POLLING = createAction(
  'vtn/redact/engine/STOP_ALL_ENGINE_POLLING'
);

export const actionStopAllEnginePolling = () => STOP_ALL_ENGINE_POLLING();
